import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import LogoBis from "../../../common/components/LogoBis/LogoBis";
import MenuHeader from "../../../common/components/MenuHeader/MenuHeader";
import PreventLeavePageItem from "../../../common/components/PreventLeavePageItem/PreventLeavePageItem";
import SecuentialSurveyItem from "../../../common/components/SecuentialSurveyItem/SecuentialSurveyItem";
import { COLORS } from "../../../common/constants/colors";
import { openNotification, tryCatch } from "../../../common/constants/Utilities";
import { VisualizacionFormulario } from "../../../common/enums/AllEnums";
import { useForm } from "../../../contexts/form";
import { IEntitySurvey } from "../../../interfaces/IEntitySurvey";
import { ActiveFormListDetailByFormID, ActiveOrBlockFormListDetail } from "../../../services/survey";
import Formularios from "../../Formularios/Formularios";



const SequentialSurvey = () => {
    const { questionForm, setFormAnswer, formAnswer, entitySurveySelected } = useForm();
    const [registrado, setRegistrado] = useState<boolean>(false)
    const navigate = useNavigate();

    // Condition to trigger the prompt.
    // PreventLeavePageItem('Desea abandonar la presente pagina ? ?', JSON.parse(localStorage.getItem('CheckLeave') || 'null'), () => desbloquearEntidad(entitySurveySelected!));

    const desbloquearEntidad = (entityToSurvey: IEntitySurvey) => {
        if (questionForm?.visualizacionTipoNombre !== VisualizacionFormulario.Tabla) {
            tryCatch(() => {
                if (questionForm?.bloquearPaginacion) {
                    if (questionForm.visualizacionTipoNombre === VisualizacionFormulario.ListadoDetalle && JSON.parse(localStorage.getItem('GoBackConfirmed') || 'null')) {
                        // es yendo hacia atras, no hacer nada.
                    } else {
                        ActiveFormListDetailByFormID(questionForm.formularioID)
                            .then((response) => {
                                //Desbloqueado Formulario listado Detalle (Lista Clientes)
                            })
                            .catch((response) => {
                                openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                            })
                            .finally(() => { });
                    }
                   
                } else {
                    ActiveOrBlockFormListDetail(entityToSurvey?.formularioListadoDetalleID!, false)
                        .then((response) => {
                            //Desbloqueado Formulario listado Detalle (Un Cliente)
                        })
                        .catch((response) => {
                            openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                        })
                        .finally(() => { });
                }

            })
        }

    }

    const gotoListadoFormularios = () => {

        localStorage.setItem('CheckLeave', JSON.stringify(false));
        const leer = JSON.parse(localStorage.getItem('CheckLeave') || 'null');
       
        !leer && navigate(`/bisformulario/encuesta`);
    }

    useEffect(() => {
        localStorage.removeItem('CheckLeave');
        setFormAnswer({
            ...formAnswer!,
            respuestaID: 0,
            formularioID: questionForm!.formularioID,
            formularioListadoDetalleID: entitySurveySelected?.formularioListadoDetalleID!, respuesta: []
        });
        localStorage.setItem('CheckLeave', JSON.stringify(true));
    }, [])

    useEffect(() => { registrado && gotoListadoFormularios() }, [registrado])

    return (

        <div>
            <div className={"nav_header"}>
                <LogoBis />
                <MenuHeader currentPage={questionForm?.nombre!} clientCode={questionForm?.visualizacionTipoNombre !== VisualizacionFormulario.Tabla? (entitySurveySelected?.nombre+" : "+entitySurveySelected?.codigo): ""}  isMenu={false} />
            </div>
            <SecuentialSurveyItem active={true}
                backgroundcolorheader={COLORS.blue_inactive(1)}
                backgroundcolorbody={COLORS.black_back_color5}
                borderColor={COLORS.black_shadow_1}
                textColor={COLORS.blue_main(1)}
                method={() => { }} item={questionForm!} setRegistrado={setRegistrado} />

            <PreventLeavePageItem
  message="¿Desea abandonar la presente página?"
  when={JSON.parse(localStorage.getItem('CheckLeave') || 'null')}
  method={() => desbloquearEntidad(entitySurveySelected!)}
/>
        </div>


    )
}

export default SequentialSurvey;